module.exports = __webpack_public_path__ + "static/TrendyHipster-9b81952e17770868d57e1df69b255cb7.jpg";